module.exports = __webpack_public_path__ + "images/file_icons_v2/php-aaece3a156f4ae86c4e907083179a46e.svg";